<template>
  <div class="HSK">
    <div class="container">
      <h2>汉语水平考试HSK</h2>
      <p>汉语水平考试（HSK）是一项国际标准化考试，重点考查汉语非第一语言的考生在生活、学习和工作中运用汉语进行交际的能力。</p>
      <p>考试等级包括HSK（一级）、HSK（二级）、HSK（三级）、HSK（四级）、HSK（五级）和HSK（六级）。</p>
      <div class="kaoshi-fenlei">
        <van-tabs border
                  animated
                  title-active-color="#263e65">
          <van-tab title="HSK一级">
            <div class="__contss">
              <p>HSK（一级）考查考生的日常汉语应用能力，它对应于《国际汉语能力标准》一级、《欧洲语言共同参考框架（CEF）》A1级。通过HSK（一级）的考生可以理解并使用一些非常简单的汉语词语和句子，满足具体的交际需求，具备进一步学习汉语的能力。</p>
              <div class="shenqingTit">一、考试对象</div>
              <p>HSK（一级）主要面向按每周2-3课时进度学习汉语一个学期（半学年），掌握150个最常用词语和相关语法知识的考生。</p>
              <div class="shenqingTit">二、考试内容</div>
              <p>HSK（一级）共40题，分听力、阅读两部分。</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w25">
                    <div class="_text">考试内容</div>

                  </div>
                  <div class="_col w50">
                    <div class="_text">试题数量</div>

                  </div>
                  <div class="_col w25">
                    <div class="_text">考试时间</div>

                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z4">一、听力</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                    <div class="_text">第三部分</div>
                    <div class="_text">第四部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">5</div>
                    <div class="_text">5</div>
                    <div class="_text">5</div>
                    <div class="_text">5</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z4">约15</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w75">
                    <div class="_text">填写答题卡(将听力部分的答案填涂到答题卡上)</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">3</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z4">二、阅读</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                    <div class="_text">第三部分</div>
                    <div class="_text">第四部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">5</div>
                    <div class="_text">5</div>
                    <div class="_text">5</div>
                    <div class="_text">5</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z4">17</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text">共计</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">/</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">40</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">约35</div>
                  </div>
                </div>
              </div>
              <p>全部考试约40分钟（含考生填写个人信息时间5分钟）。</p>
              <p class="ted0"><b>1．听力</b></p>
              <p>第一部分，共5题。每题听两次。每题都是一个短语，试卷上提供一张图片，考生根据听到的内容判断对错。</p>
              <p>第二部分，共5题。每题听两次。每题都是一个句子，试卷上提供3张图片，考生根据听到的内容选出对应的图片。</p>
              <p>第三部分，共5题。每题听两次。每题都是一个对话，试卷上提供几张图片，考生根据听到的内容选出对应的图片。</p>
              <p>第四部分，共5题。每题听两次。每题都是一个人说一句话，第二个人根据这句话问一个问题并说出3个选项，试卷上每题都有3个选项，考生根据听到的内容选出答案。</p>
              <p class="ted0"><b>2．阅读</b></p>
              <p>第一部分，共5题。每题提供一张图片和一个词语，考生要判断是否一致。</p>
              <p>第二部分，共5题。试卷上有几张图片，每题提供一个句子，考生根据句子内容，选出对应的图片。</p>
              <p>第三部分，共5题。提供5个问句和5个回答，考生要找出对应关系。</p>
              <p>第四部分，共5题。每题提供一个句子，句子中有一个空格，考生要从提供的选项中选词填空。</p>
              <p>试卷上的试题都加拼音。</p>
              <div class="shenqingTit">三、成绩报告</div>
              <p>HSK（一级）成绩报告提供听力、阅读和总分三个分数。总分120分为合格。</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">满分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">你的分数</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">听力</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">阅读</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">总分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">200</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
              </div>
              <p>HSK成绩长期有效。作为外国留学生进入中国院校学习的汉语能力的证明，HSK成绩有效期为两年（从考试当日算起）。</p>
            </div>
          </van-tab>
          <van-tab title="HSK二级">
            <div class="__contss">
              <p>HSK（二级）考查考生的日常汉语应用能力，它对应于《国际汉语能力标准》二级、《欧洲语言共同参考框架（CEF）》A2级。通过HSK（二级）的考生可以用汉语就熟悉的日常话题进行简单而直接的交流，达到初级汉语优等水平。</p>
              <div class="shenqingTit">一、考试对象</div>
              <p>HSK（二级）主要面向按每周2-3课时进度学习汉语两个学期（一学年），掌握300个最常用词语和相关语法知识的考生。</p>
              <div class="shenqingTit">二、考试内容</div>
              <p>HSK（一级）共40题，分听力、阅读两部分。</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w25">
                    <div class="_text">考试内容</div>

                  </div>
                  <div class="_col w50">
                    <div class="_text">试题数量</div>

                  </div>
                  <div class="_col w25">
                    <div class="_text">考试时间</div>

                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z4">一、听力</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                    <div class="_text">第三部分</div>
                    <div class="_text">第四部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">10</div>
                    <div class="_text">10</div>
                    <div class="_text">10</div>
                    <div class="_text">10</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z4">约35</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w75">
                    <div class="_text">填写答题卡(将听力部分的答案填涂到答题卡上)</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">3</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z4">二、阅读</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                    <div class="_text">第三部分</div>
                    <div class="_text">第四部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">5</div>
                    <div class="_text">5</div>
                    <div class="_text">5</div>
                    <div class="_text">10</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z4">22</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text">共计</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">/</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">60</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">约50</div>
                  </div>
                </div>
              </div>
              <p>全部考试约55分钟（含考生填写个人信息时间5分钟）。</p>
              <p class="ted0"><b>1．听力</b></p>
              <p>第一部分，共10题。每题听两次。每题都是一个句子，试卷上提供一张图片，考生根据听到的内容判断对错。</p>
              <p>第二部分，共10题。每题听两次。每题都是一个对话，试卷上提供几张图片，考生根据听到的内容选出对应的图片。</p>
              <p>第三部分，共10题。每题听两次。每题都是两个人的两句对话，第三个人根据对话问一个问题，试卷上提供3个选项，考生根据听到的内容选出答案。</p>
              <p>第四部分，共5题。每题听两次。每题都是两个人的4到5句对话，第三个人根据对话问一个问题，试卷上提供3个选项，考生根据听到的内容选出答案。</p>
              <p class="ted0"><b>2．阅读</b></p>
              <p>第一部分，共5题。试卷上有几张图片，每题提供一个句子，考生根据句子内容，选出对应的图片。</p>
              <p>第二部分，共5题。每题提供一到两个句子，句子中有一个空格，考生要从提供的选项中选词填空。</p>
              <p>第三部分，共5题。每题提供两个句子，考生要判断第二句内容与第一句是否一致。</p>
              <p>第四部分，共10题。提供20个句子，考生要找出对应关系。</p>
              <p>试卷上的试题都加拼音。</p>
              <div class="shenqingTit">三、成绩报告</div>
              <p>HSK（二级）成绩报告提供听力、阅读和总分三个分数。总分120分为合格。</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w33">
                    <div class="_text"></div>

                  </div>
                  <div class="_col w33">
                    <div class="_text">满分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">你的分数</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">听力</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">阅读</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">总分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">200</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
              </div>
              <p>HSK成绩长期有效。作为外国留学生进入中国院校学习的汉语能力的证明，HSK成绩有效期为两年（从考试当日算起）。</p>
            </div>
          </van-tab>
          <van-tab title="HSK三级">
            <div class="__contss">
              <p>HSK（三级）考查考生的汉语应用能力，它对应于《国际汉语能力标准》三级、《欧洲语言共同参考框架（CEF）》B1级。通过HSK（三级）的考生可以用汉语完成生活、学习、工作等方面的基本交际任务，在中国旅游时，可应对遇到的大部分交际任务。</p>
              <div class="shenqingTit">一、考试对象</div>
              <p>HSK（三级）主要面向掌握600个最常用词语和相关语法知识的考生。</p>
              <div class="shenqingTit">二、考试内容</div>
              <p>HSK（三级）共80题，分听力、阅读、书写三部分。</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w25">
                    <div class="_text">考试内容</div>

                  </div>
                  <div class="_col w50">
                    <div class="_text">试题数量</div>

                  </div>
                  <div class="_col w25">
                    <div class="_text">考试时间</div>

                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z4">一、听力</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                    <div class="_text">第三部分</div>
                    <div class="_text">第四部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">10</div>
                    <div class="_text">10</div>
                    <div class="_text">10</div>
                    <div class="_text">10</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z4">约35</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w75">
                    <div class="_text">填写答题卡(将听力部分的答案填涂到答题卡上)</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">3</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z4">二、阅读</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                    <div class="_text">第三部分</div>
                    <div class="_text">第四部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">10</div>
                    <div class="_text">10</div>
                    <div class="_text">10</div>
                    <div class="_text">10</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z4">22</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z2">三、书写</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">5</div>
                    <div class="_text">5</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z2">15</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text">共计</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">/</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">80</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">约85</div>
                  </div>
                </div>
              </div>
              <p>全部考试约90分钟（含考生填写个人信息时间5分钟）。</p>
              <p class="ted0"><b>1．听力</b></p>
              <p>第一部分，共10题。每题听两次。每题都是一个对话，试卷上提供几张图片，考生根据听到的内容选出对应的图片。</p>
              <p>第二部分，共10题。每题听两次。每题都是一个人先说一小段话，另一人根据这段话说一个句子，试卷上也提供这个句子，要求考生判断对错。</p>
              <p>第三部分，共10题。每题听两次。每题都是两个人的两句对话，第三个人根据对话问一个问题，试卷上提供3个选项，考生根据听到的内容选出答案。</p>
              <p>第四部分，共10题。每题听两次。每题都是两个人的4到5句对话，第三个人根据对话问一个问题，试卷上提供3个选项，考生根据听到的内容选出答案。</p>
              <p class="ted0"><b>2．阅读</b></p>
              <p>第一部分，共10题。提供20个句子，考生要找出对应关系。</p>
              <p>第二部分，共10题。每题提供一到两个句子，句子中有一个空格，考生要从提供的选项中选词填空。</p>
              <p>第三部分，共10题。提供10小段文字，每段文字带一个问题，考生要从3个选项中选出答案。</p>
              <p class="ted0"><b>3．书写</b></p>
              <p>第一部分，共5题。每题提供几个词语，要求考生用这几个词语写一个句子。</p>
              <p>第二部分，共5题。每题提供一个带空格的句子，要求考生在空格上写正确的汉字。</p>
              <div class="shenqingTit">三、成绩报告</div>
              <p>HSK（三级）成绩报告提供听力、阅读、书写和总分四个分数。总分180分为合格。</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">满分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">你的分数</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">听力</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">阅读</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">书写</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">总分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">300</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
              </div>
              <p>HSK成绩长期有效。作为外国留学生进入中国院校学习的汉语能力的证明，HSK成绩有效期为两年（从考试当日算起）。</p>
            </div>
          </van-tab>
          <van-tab title="HSK四级">
            <div class="__contss">
              <p>HSK（四级）考查考生的汉语应用能力，它对应于《国际汉语能力标准》四级、《欧洲语言共同参考框架（CEF）》B2级。通过HSK（四级）的考生可以用汉语就较广泛领域的话题进行谈论，比较流利地与汉语为母语者进行交流。</p>
              <div class="shenqingTit">一、考试对象</div>
              <p>HSK（四级）主要面向按每周2-4课时进度学习汉语四个学期（两学年），掌握1200个常用词语的考生。</p>
              <div class="shenqingTit">二、考试内容</div>
              <p>HSK（四级）共100题，分听力、阅读、书写三部分。</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w25">
                    <div class="_text">考试内容</div>

                  </div>
                  <div class="_col w50">
                    <div class="_text">试题数量</div>

                  </div>
                  <div class="_col w25">
                    <div class="_text">考试时间</div>

                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z3">一、听力</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                    <div class="_text">第三部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">10</div>
                    <div class="_text">15</div>
                    <div class="_text">20</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z3">约30</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w75">
                    <div class="_text">填写答题卡(将听力部分的答案填涂到答题卡上)</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">3</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z3">二、阅读</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                    <div class="_text">第三部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">10</div>
                    <div class="_text">10</div>
                    <div class="_text">20</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z3">40</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z2">三、书写</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">10</div>
                    <div class="_text">5</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z2">25</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text">共计</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">/</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">约100</div>
                  </div>
                </div>
              </div>
              <p>全部考试约105分钟（含考生填写个人信息时间5分钟）。</p>
              <p class="ted0"><b>1．听力</b></p>
              <p>第一部分，共10题。每题听一次。每题都是一个人先说一小段话，另一人根据这段话说一个句子，试卷上也提供这个句子，要求考生判断对错。</p>
              <p>第二部分，共15题。每题听一次。每题都是两个人的两句对话，第三个人根据对话问一个问题，试卷上提供4个选项，考生根据听到的内容选出答案。</p>
              <p>第三部分，共20题。每题听一次。这部分试题都是4到5句对话或一小段话，根据对话或语段问一到两个问题，试卷上每题提供4个选项，考生根据听到的内容选出答案。</p>
              <p class="ted0"><b>2．阅读</b></p>
              <p>第一部分，共10题。每题提供一到两个句子，句子中有一个空格，考生要从提供的选项中选词填空。</p>
              <p>第二部分，共10题。每题提供3个句子，考生要把这3个句子按顺序排列起来。</p>
              <p>第三部分，共20题。这部分试题都是一小段文字，每段文字带一到两个问题，考生要从4个选项中选出答案。</p>
              <p class="ted0"><b>3．书写</b></p>
              <p>第一部分，共10题。每题提供几个词语，要求考生用这几个词语写一个句子。</p>
              <p>第二部分，共5题。每题提供一张图片和一个词语，要求考生结合图片用这个词语写一个句子。</p>
              <div class="shenqingTit">三、成绩报告</div>
              <p>HSK（四级）成绩报告提供听力、阅读、书写和总分四个分数。总分180分为合格。</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">满分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">你的分数</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">听力</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">阅读</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">书写</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">总分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">300</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
              </div>
              <p>HSK成绩长期有效。作为外国留学生进入中国院校学习的汉语能力的证明，HSK成绩有效期为两年（从考试当日算起）。</p>
            </div>
          </van-tab>
          <van-tab title="HSK五级">
            <div class="__contss">
              <p>HSK（五级）考查考生的汉语应用能力，它对应于《国际汉语能力标准》五级、《欧洲语言共同参考框架（CEF）》C1级。通过HSK（五级）的考生可以阅读汉语报刊杂志，欣赏汉语影视节目，用汉语进行较为完整的演讲。</p>
              <div class="shenqingTit">一、考试对象</div>
              <p>HSK（五级）主要面向按每周2-4课时进度学习汉语两年以上，掌握2500个常用词语的考生。</p>
              <div class="shenqingTit">二、考试内容</div>
              <p>HSK（五级）共100题，分听力、阅读、书写三部分。</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w25">
                    <div class="_text">考试内容</div>

                  </div>
                  <div class="_col w50">
                    <div class="_text">试题数量</div>

                  </div>
                  <div class="_col w25">
                    <div class="_text">考试时间</div>

                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z2">一、听力</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">20</div>
                    <div class="_text">25</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z2">约30</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w75">
                    <div class="_text">填写答题卡(将听力部分的答案填涂到答题卡上)</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">5</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z3">二、阅读</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                    <div class="_text">第三部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">15</div>
                    <div class="_text">10</div>
                    <div class="_text">20</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z3">45</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z2">三、书写</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">8</div>
                    <div class="_text">2</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z2">40</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text">共计</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">/</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">约120</div>
                  </div>
                </div>
              </div>
              <p>全部考试约105分钟（含考生填写个人信息时间5分钟）。</p>
              <p class="ted0"><b>1．听力</b></p>
              <p>第一部分，共20题。每题听一次。每题都是两个人的两句对话，第三个人根据对话问一个问题，试卷上提供4个选项，考生根据听到的内容选出答案。</p>
              <p>第二部分，共25题。每题听一次。这部分试题都是4到5句对话或一段话，根据对话或语段问一个或几个问题，试卷上每题提供4个选项，考生根据听到的内容选出答案。</p>
              <p class="ted0"><b>2．阅读</b></p>
              <p>第一部分，共15题。提供几篇文字，每篇文字中有几个空格，空格中应填入一个词语或一个句子，每个空格有4个选项，考生要从中选出答案。</p>
              <p>第二部分，共10题。每题提供一段文字和4个选项，考生要选出与这段文字内容一致的一项。</p>
              <p>第三部分，共20题。提供几篇文字，每篇文字带几个问题，考生要从4个选项中选出答案。</p>
              <p class="ted0"><b>3．书写</b></p>
              <p>第一部分，共8题。每题提供几个词语，要求考生用这几个词语写一个句子。</p>
              <p>第二部分，共2题。第一题提供几个词语，要求考生用这几个词语写一篇80字左右的短文；第二题提供一张图片，要求考生结合图片写一篇80字左右的短文。</p>
              <div class="shenqingTit">三、成绩报告</div>
              <p>HSK（五级）成绩报告提供听力、阅读、书写和总分四个分数。</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">满分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">你的分数</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">听力</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">阅读</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">书写</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">总分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">300</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
              </div>
              <p>HSK成绩长期有效。作为外国留学生进入中国院校学习的汉语能力的证明，HSK成绩有效期为两年（从考试当日算起）。</p>
            </div>
          </van-tab>
          <van-tab title="HSK六级">
            <div class="__contss">
              <p>HSK（六级）考查考生的汉语应用能力，它对应于《国际汉语能力标准》五级、《欧洲语言共同参考框架（CEF）》C2级。通过HSK（六级）的考生可以轻松地理解听到或读到的汉语信息，以口头或书面的形式用汉语流利地表达自己的见解。</p>
              <div class="shenqingTit">一、考试对象</div>
              <p>HSK（六级）主要面向掌握5000及5000以上常用词语的考生。</p>
              <div class="shenqingTit">二、考试内容</div>
              <p>HSK（六级）共101题，分听力、阅读、书写三部分。</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w25">
                    <div class="_text">考试内容</div>
                  </div>
                  <div class="_col w50">
                    <div class="_text">试题数量</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">考试时间</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z3">一、听力</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                    <div class="_text">第三部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">15</div>
                    <div class="_text">15</div>
                    <div class="_text">20</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z3">约35</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w75">
                    <div class="_text">填写答题卡(将听力部分的答案填涂到答题卡上)</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">5</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z4">二、阅读</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                    <div class="_text">第三部分</div>
                    <div class="_text">第四部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">10</div>
                    <div class="_text">10</div>
                    <div class="_text">10</div>
                    <div class="_text">20</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z4">50</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text">三、书写</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">作文</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">1</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">45</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text">共计</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">/</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">101</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">约135</div>
                  </div>
                </div>
              </div>
              <p>全部考试约140分钟（含考生填写个人信息时间5分钟）。</p>
              <p class="ted0"><b>1．听力</b></p>
              <p>第一部分，共15题。每题听一次。每题播放一小段话，试卷上提供4个选项，考生根据听到的内容选出与其一致的一项。</p>
              <p>第二部分，共15题。每题听一次。播放三段采访，每段采访后带5个试题，试卷上每题提供4个选项，考生根据听到的内容选出答案。</p>
              <p>第三部分，共20题。每题听一次。播放若干段话，每段话后带几个问题，试卷上每题提供4个选项，考生根据听到的内容选出答案。</p>
              <p class="ted0"><b>2．阅读</b></p>
              <p>第一部分，共10题。每题提供4个句子，要求考生选出有语病的一句。</p>
              <p>第二部分，共10题。每题提供一小段文字，其中有3到5个空格，考生要结合语境，从4个选项中选出最恰当的答案。</p>
              <p>第三部分，共10题。提供两篇文字，每篇文字有5个空格，考生要结合语境，从提供的5个句子选项中选出答案。</p>
              <p>第四部分，共20题。提供若干篇文字，每篇文字带几个问题，考生要从4个选项中选出答案。</p>
              <p class="ted0"><b>3．书写</b></p>
              <p>考生先要阅读一篇1000字左右的叙事文章，时间为10分钟，阅读时不能抄写和记录；监考将阅读材料收回后，请将这篇文章缩写为一篇400字左右的短文，时间为35分钟。标题自拟。只需复述文章内容，不需加入自己的观点。</p>
              <div class="shenqingTit">三、成绩报告</div>
              <p>HSK（六级）成绩报告提供听力、阅读、书写和总分四个分数。</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">满分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">你的分数</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">听力</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">阅读</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">书写</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">总分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">300</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                </div>
              </div>
              <p>HSK成绩长期有效。作为外国留学生进入中国院校学习的汉语能力的证明，HSK成绩有效期为两年（从考试当日算起）。</p>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="botline">
      没有更多了
    </div>
    <van-popup v-model="showForm"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="FormCont">
        <ComForm @hideForm="hideForm"
                 :typeId=formType
                 :formTitle="formtit"
                 ref="comForm"></ComForm>
      </div>
    </van-popup>
    <van-popup v-model="showForm2"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="FormCont">
        <HSKForm @hideForm="hideForm"
                 ref="HSKForm"></HSKForm>
      </div>
    </van-popup>
    <van-popup v-model="showForm3"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="FormCont">
        <BCTForm @hideForm="hideForm"
                 ref="BCTForm"></BCTForm>
      </div>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import ComForm from '@/components/ComForm'
import HSKForm from '@/components/HSKForm'
import BCTForm from '@/components/BCTForm'

export default {
  name: 'Jieji',
  components: {
    ComForm,
    HSKForm,
    BCTForm
  },
  data () {
    return {
      activeNames: ['0'],
      showForm: false,
      showForm2: false,
      showForm3: false,
      formtit: '',
      formType: ''
    }
  },
  methods: {
    hideForm () {
      this.showForm = false
      this.showForm2 = false
      this.showForm3 = false
    },
    clearForm () {
      this.$refs.comForm.clearForm()
    },
    onShowForm (id, val) {
      this.formType = id
      this.formtit = val
      this.showForm = true
    }
  }
}
</script>

<style lang="scss" scoped>
.Jieji {
  height: 100%;
  overflow: auto;
}
h2 {
  text-align: center;
}
p {
  margin-bottom: 20px;
  font-size: 28px;
  text-indent: 2em;
  &._c {
    text-align: center;
    text-indent: 0;
  }
  &.ted0 {
    text-indent: 0;
  }
}
.container {
  padding-bottom: 0;
  h4 {
    margin: 0;
  }
  font-size: 28px;

  .tips {
    color: #f29810;
    margin: 10px 0;
  }
  .tips_p {
    color: #545454;
  }
  .tips_lis {
    margin-top: 10px;
    color: #545454;
  }
  .tit1 {
    font-size: 32px;
    font-weight: bold;
    color: #f29810;
    text-align: center;
    margin-bottom: 20px;
  }
  .buzhu {
    h3 {
      margin-bottom: 20px;
      color: #263e65;
    }
    .lis {
      padding: 20px;
      box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
    }
    p {
      text-indent: 0;
      margin: 0;
      margin-top: 20px;
      color: #545454;
      font-size: 26px;
      a {
        color: #263e65;
      }
    }
  }
  .shenqingTit {
    border-left: 10px solid #263e65;
    line-height: 1;
    font-size: 32px;
    margin: 30px 0;
    padding-left: 10px;
  }
}

.cont-card {
  padding: 20px 0;
}

._baoming {
  padding: 20px;
  p {
    text-indent: 0;
    text-align: center;
  }
}
._lis {
  box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
  border-radius: 15px;
  margin-bottom: 40px;
  overflow: hidden;
  .text {
    padding: 20px;
    h5 {
      font-size: 36px;
      margin: 0;
      margin-bottom: 20px;
      color: #333;
    }
    p {
      text-indent: 0;
      color: #545454;
    }
  }
}
.kaoshi-fenlei {
  .kaoshi-cont {
    padding: 20px;
    h3 {
      font-size: 32px;
      margin-bottom: 20px;
      span {
        font-size: 58px;
        color: #263e65;
        margin-right: 10px;
      }
    }
    p {
      text-indent: 0;
      color: #545454;
    }
  }
  .btns {
    ._btn {
      display: block;
      background-color: #f6cb47;
      color: #fff;
      border-radius: 10px;
      padding: 20px 0;
      text-align: center;
      margin: 0 auto;
      margin-top: 20px;
      width: 95%;
    }
  }
}

.__contss {
  padding: 20px 0;
  ._table {
    width: 660px;
    margin: auto;
    border: 1px solid #dedede;
    margin-bottom: 10px;
    ._thead {
      background-color: #f1f1f1;
    }
    ._row {
      display: flex;
    }
    .w33 {
      width: 220px;
    }
    .w25 {
      width: 165px;
    }
    .w50 {
      width: 330px;
    }
    .w75 {
      width: 495px;
    }
    ._col {
      border-right: 1px solid #dedede;
      border-bottom: 1px solid #dedede;
      margin-bottom: -1px;
      box-sizing: border-box;
      &:last-child {
        border-right: none;
      }
    }
    ._text {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100px;
      padding: 0 20px;
    }
    .z2 {
      height: 200px;
    }
    .z3 {
      height: 300px;
    }
    .z4 {
      height: 400px;
    }
  }
}
</style>
<style lang="scss">
.van-step--finish .van-step__circle,
.van-step--finish .van-step__line {
  background-color: #263e65;
}
</style>
